import React from "react";
import { Button, Container, Row, Col, Form, Dropdown, DropdownButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import Locale from "../../locale/Locale";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import Pager from './components/Pager';

export default class SearchScreen extends React.Component {
    state = { 
        searchTerm: "",
        sortBy: 'id',
        sortDir: 'ASC',
        pageSize: 30,
        page: 0,
        list: null,
        totalCount: 0,
        extraParams: {}
    }
    _ismounted = false;
    searchEnabled = true;
    addEnabled = false;
    extraElement = null;
    filterControls = null;

    componentDidMount() {
        this._ismounted = true;
        const match = context.matchPath(this.pathPrefix);
        this.setState({ pathParams: match.params });
        if (!match.params.recordId || this.state.list === null) {
            this.updateList(this.state.searchTerm);
        }
    }
    
    componentWillUnmount() {
        this._ismounted = false;
    }

    updateSearch(searchTerm, page) {
        this.updateList(searchTerm || this.state.searchTerm, page);
    }

    sortPushed(field) {
        let newDir = this.state.sortBy === field ? this.state.sortDir === "ASC" ? "DESC" : "ASC" : this.state.sortDir;
                        this.setState({
                            sortBy: field,
                            sortDir: newDir
                        }, () => {
                            this.updateList(this.state.searchTerm, this.state.page);      
                        });   
    }

    getSortIndicator(field) {
        return this.state.sortBy === field ? (this.state.sortDir === "ASC" ? <FaIcons.FaArrowDown /> : <FaIcons.FaArrowUp />) : null;
    }

    async updateList(searchTerm, page) {
        this.setState({
            list: [],
            loading: true,
            totalCount: 0
        });
        try {
            page = Number.isInteger(page) ? page : this.state.page;
            let pageSize = this.state.pageSize || 15;
            let params = Object.assign({}, {
                adminApi: true,
                phrase: searchTerm || "",
                sortBy: this.state.sortBy,
                sortDirection: this.state.sortDir,
                page: page,
                pageSize: pageSize
            }, this.state.extraParams);
            let list = await context.makeRequest(this.methodName, params);
            
            if (!this._ismounted)
                return;
            
            if (typeof list.result?.totalItemCount !== "undefined" && list.result?.totalItemCount < page * pageSize) {
                let newPage = Math.floor(list.result.totalItemCount / pageSize);
                this.setState({ page: newPage }, () => {
                    this.updateList(searchTerm, newPage);
                });
                return;
            }

            if (Array.isArray(list.result)) {
                this.setState({ 
                    totalCount: list.result.length,
                    loading: false,
                    searchTerm: searchTerm,
                    list: list.result,
                    page: page
                });
            } else if (list.result) {
                let itemList = Array.isArray(list.result) ? list.result : list.result.items;
                this.setState({ 
                    totalCount: list.result.totalItemCount,
                    searchTerm: searchTerm, 
                    loading: false,
                    list: itemList,
                    page: page
                });
            } else {
                this.setState({ 
                    loading: false,
                    searchTerm: searchTerm,
                    list: [] 
                });
            }
        } catch (err) {
            console.error(err);
            this.setState({
                loading: false,
            });
        }
    }
    
    refreshPushed() {
        this.updateList(this.state.searchTerm);
    }
    
    addPushed() {
        alert("Not implemented");
    }

    itemRenderer(item) {
        return (
            <ListGroup.Item action 
                key={item.uuid} 
                onClick={ context.navigate(this.pathPrefix + "/" + item.uuid, item.uuid) }
                className="listItem"
            >
                <div>{ item.name }</div> <br/>
                <div>{ item.owner && item.owner.email } - { item.city }, { item.country }</div>
            </ListGroup.Item> 
        )
    }

    render() { 
        const match = context.matchPath(this.pathPrefix);
        
        if (match?.params.recordId) {
            let DetailComponent = this.detailComponent;
            return (
                <DetailComponent/>
            )
        }
        let content = (
            <ListGroup  style={{ overflowY: 'auto' }}>
                { this.renderHeader ? this.renderHeader() : null }
                { Array.isArray(this.state.list) && this.state.list.length > 0 ? this.state.list.map(this.itemRenderer.bind(this)) : "Empty list" }
            </ListGroup>
        );
        if (this.state.loading) {
            content = "Loading...";
        }
        return ( 
            <div style={{ flexDirection: 'column', display: 'flex', height: '100%', overflow: 'hidden' }}>
                { this.extraElement }
                <Form.Group>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {
                            this.addEnabled ? (        
                                <div>
                                    <Button onClick={ 
                                        this.addPushed.bind(this) 
                                    } style={{ marginRight: 10 }}>Add</Button>
                                </div>
                            ) : null
                        }
                        {
                            this.searchEnabled ? (  
                                <div style={{ flex: 1, marginRight: 20 }}>
                                    <Form.Control 
                                        placeholder="Search" 
                                        type="text"
                                        onKeyPress={(e) => e.charCode === 13 ? this.updateSearch(null, 0) : "" }
                                        onChange={ (event) => { this.setState({ searchTerm: event.target.value }) }} 
                                    />
                                </div>
                            ) : null
                        }
                        { typeof this.filterControls === "function" ? this.filterControls() : this.filterControls }
                        <div style={{ width: 50, marginRight: 20, display: (this.state.pageSize ? "block" : "none") }}>
                            <DropdownButton
                                title={ this.state.pageSize }
                            >
                                <Dropdown.Item onClick={ () => this.setState({ pageSize: 10 }, () => this.refreshPushed()) }>10</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.setState({ pageSize: 30 }, () => this.refreshPushed()) }>30</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.setState({ pageSize: 50 }, () => this.refreshPushed()) }>50</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.setState({ pageSize: 100 }, () => this.refreshPushed()) }>100</Dropdown.Item>
                            </DropdownButton>
                        </div>
                        <div>
                            <Button onClick={ 
                                this.refreshPushed.bind(this) 
                            } >
                                <MdIcons.MdRefresh />{ Locale.gettext("Refresh") }
                            </Button>
                        </div>
                    </div>
                    <div id="pager" style={{ width: '100%', paddingTop: 10, height: 30, display: (this.state.totalCount ? "block" : "none") }}>
                        <Pager
                            directPageCount={ 7 }
                            currentPage={ this.state.page + 1 } 
                            totalCount={ this.state.totalCount } 
                            pageSize={ this.state.pageSize }
                            onChange={(page) => {
                                this.setState({
                                    page: page - 1
                                }, () => {
                                    this.updateSearch();
                                });
                            }}
                        />
                    </div>
                </Form.Group> 
                { content }
            </div>
        );
    }

    calcTime(time) {
        if (!time) {
            return "Never";
        } 
        let nowMs = new Date().getTime();
        let timeMs = new Date(time).getTime();
        let diffSecs = (nowMs - timeMs) / 1000;
        let timeStr = Math.floor(diffSecs) + " seconds";
        if (diffSecs > (3600 * 24)) {
            timeStr = Math.floor(diffSecs / (3600 * 24)) + " days";
        } else if (diffSecs > 3600) {
            timeStr = Math.floor(diffSecs / 3600) + " hours";
        } else if (diffSecs > 60) {
            timeStr = Math.floor(diffSecs / 60) + " minutes";
        }

        return timeStr + " ago";
    }
}